package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.LanguageW500Rounded: ImageVector
    get() {
        if (_languageW500Rounded != null) {
            return _languageW500Rounded!!
        }
        _languageW500Rounded = Builder(name = "LanguageW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(321.89f, 855.91f)
                quadToRelative(-74.43f, -32.21f, -130.01f, -87.79f)
                quadToRelative(-55.58f, -55.58f, -87.79f, -130.01f)
                quadToRelative(-32.22f, -74.44f, -32.22f, -158.49f)
                quadToRelative(0.0f, -84.05f, 32.22f, -158.11f)
                quadToRelative(32.21f, -74.05f, 87.79f, -129.63f)
                quadToRelative(55.58f, -55.58f, 130.01f, -87.79f)
                quadToRelative(74.44f, -32.22f, 158.49f, -32.22f)
                quadToRelative(84.05f, 0.0f, 158.11f, 32.22f)
                quadToRelative(74.05f, 32.21f, 129.63f, 87.79f)
                quadToRelative(55.58f, 55.58f, 87.79f, 129.63f)
                quadToRelative(32.22f, 74.06f, 32.22f, 158.11f)
                quadToRelative(0.0f, 84.05f, -32.22f, 158.49f)
                quadToRelative(-32.21f, 74.43f, -87.79f, 130.01f)
                quadToRelative(-55.58f, 55.58f, -129.63f, 87.79f)
                quadToRelative(-74.06f, 32.22f, -158.11f, 32.22f)
                quadToRelative(-84.05f, 0.0f, -158.49f, -32.22f)
                close()
                moveTo(479.52f, 795.37f)
                quadToRelative(25.05f, -35.52f, 44.05f, -74.4f)
                quadToRelative(19.0f, -38.88f, 31.0f, -82.4f)
                lineTo(405.2f, 638.57f)
                quadToRelative(12.0f, 43.52f, 30.64f, 82.4f)
                reflectiveQuadToRelative(43.68f, 74.4f)
                close()
                moveTo(376.72f, 779.37f)
                quadToRelative(-18.48f, -32.52f, -31.5f, -68.02f)
                quadToRelative(-13.02f, -35.5f, -22.02f, -72.78f)
                lineTo(206.63f, 638.57f)
                quadToRelative(28.28f, 49.52f, 71.42f, 86.28f)
                quadToRelative(43.15f, 36.76f, 98.67f, 54.52f)
                close()
                moveTo(582.57f, 779.37f)
                quadToRelative(55.52f, -17.76f, 98.9f, -54.52f)
                quadToRelative(43.38f, -36.76f, 71.66f, -86.28f)
                lineTo(636.57f, 638.57f)
                quadToRelative(-9.0f, 37.28f, -22.27f, 72.78f)
                quadToRelative(-13.26f, 35.5f, -31.73f, 68.02f)
                close()
                moveTo(172.87f, 559.28f)
                lineTo(307.2f, 559.28f)
                quadToRelative(-3.0f, -20.0f, -4.5f, -39.26f)
                quadToRelative(-1.5f, -19.26f, -1.5f, -40.02f)
                quadToRelative(0.0f, -21.0f, 1.5f, -40.14f)
                reflectiveQuadToRelative(4.5f, -39.14f)
                lineTo(172.87f, 400.72f)
                quadToRelative(-5.0f, 19.76f, -7.5f, 39.02f)
                reflectiveQuadToRelative(-2.5f, 40.26f)
                quadToRelative(0.0f, 20.76f, 2.5f, 40.14f)
                reflectiveQuadToRelative(7.5f, 39.14f)
                close()
                moveTo(387.2f, 559.28f)
                horizontalLineToRelative(185.37f)
                quadToRelative(3.0f, -20.0f, 4.26f, -39.26f)
                quadToRelative(1.26f, -19.26f, 1.26f, -40.02f)
                quadToRelative(0.0f, -21.0f, -1.26f, -40.14f)
                reflectiveQuadToRelative(-4.26f, -39.14f)
                lineTo(387.2f, 400.72f)
                quadToRelative(-3.0f, 20.0f, -4.5f, 39.14f)
                reflectiveQuadTo(381.2f, 480.0f)
                quadToRelative(0.0f, 20.76f, 1.5f, 40.02f)
                reflectiveQuadToRelative(4.5f, 39.26f)
                close()
                moveTo(652.57f, 559.28f)
                horizontalLineToRelative(134.08f)
                quadToRelative(5.0f, -19.76f, 7.5f, -39.14f)
                reflectiveQuadToRelative(2.5f, -40.14f)
                quadToRelative(0.0f, -21.0f, -2.5f, -40.26f)
                quadToRelative(-2.5f, -19.26f, -7.5f, -39.02f)
                lineTo(652.57f, 400.72f)
                quadToRelative(2.76f, 20.0f, 4.14f, 39.14f)
                reflectiveQuadToRelative(1.38f, 40.14f)
                quadToRelative(0.0f, 20.76f, -1.38f, 40.02f)
                reflectiveQuadToRelative(-4.14f, 39.26f)
                close()
                moveTo(636.57f, 321.2f)
                horizontalLineToRelative(116.56f)
                quadToRelative(-28.28f, -49.53f, -71.66f, -86.17f)
                quadToRelative(-43.38f, -36.64f, -98.9f, -54.4f)
                quadToRelative(18.47f, 32.52f, 31.73f, 67.9f)
                quadToRelative(13.27f, 35.38f, 22.27f, 72.67f)
                close()
                moveTo(405.2f, 321.2f)
                horizontalLineToRelative(149.37f)
                quadToRelative(-11.77f, -43.53f, -30.77f, -82.29f)
                quadToRelative(-19.0f, -38.76f, -44.28f, -74.28f)
                quadToRelative(-25.04f, 35.52f, -43.68f, 74.28f)
                reflectiveQuadTo(405.2f, 321.2f)
                close()
                moveTo(206.63f, 321.2f)
                lineTo(323.2f, 321.2f)
                quadToRelative(9.0f, -37.29f, 22.02f, -72.67f)
                reflectiveQuadToRelative(31.5f, -67.9f)
                quadToRelative(-55.52f, 17.76f, -98.67f, 54.4f)
                quadToRelative(-43.14f, 36.64f, -71.42f, 86.17f)
                close()
            }
        }
        .build()
        return _languageW500Rounded!!
    }

private var _languageW500Rounded: ImageVector? = null
